
import {
    Box, TextField, FormControl, InputAdornment, InputLabel, Input, IconButton, Button,
    Typography, Select, MenuItem, FormHelperText, Alert, Checkbox
} from '@mui/material';
import { AccountCircleOutlined, Visibility, VisibilityOff, LockOutlined, Group } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch, } from 'react-redux';
import { set, uniqBy } from 'lodash';
import { Tabs } from '../../components/tabs';
import { Grid } from '../../components/table';
import { CONFIG } from '../../../config'
import axios from 'axios';
import { ToolBar } from '../../components/toolbar';
import { Modal } from '../../components/modal';
import { FormA } from '../../components/form';
import moment from 'moment';
import { getFormState } from '../../../helpers/form';
import dayjs from 'dayjs';
import { SelectA } from '../../components/form';
import {ResourceAssignment} from '../resource-management/assign';
import { EmployeePMU } from './pmu';
import { EmployeePOC } from './poc';
import {Employee} from './employee';
import Teams from './teams';
import Projects from './projects';
const {uniq} = require('lodash');

const API_HOST = CONFIG.modules['accounts'].host



const items = {
    'Employee Database': {
        name: 'Employee Database',
        view: ()=> <Employee/>
    },
    // 'Designation': {
    //     name: 'Designation',
    //     view: ()=> <ResourceAssignment/>
    // },
    'PMU Database': {
        name: 'PMU Database',
        view: ()=> <EmployeePMU/>
    },
    'POC for Leaves Database': {
        name: 'POC for Leaves Database',
        view: ()=> <EmployeePOC/>
    },
    'Teams': {
        name: 'Teams',
        view: ()=> <Teams/>
        // view: ()=> <Projects/>
    },


}



export const EmployeeManagement = (props) => {
    const { roles, user, users, Designations, Departments, Languages, Districts, TaskTypes, Campaigns } = useSelector((state) => (state.user || {}))
    const [active, setActive] = useState('Employee Database');
 
    return (
        <>
            <Tabs items={items} active={active} onChange={(key) => {
                setActive(key)
            }} />
           
           {
                items[active]&& items[active].view &&
                items[active].view()
            }
        </>
    )
}